// core
import React from 'react';
import { Link } from 'react-router-dom'

// settings + utils
import Settings from 'config.js';
import Auth from 'services/Auth.js';
import API from 'utils/API.js';
import CSV from 'utils/CSV.js';

// lib
import Page from 'pages/shared/Page';
import Spinner from 'components/shared/Spinner';

// shared
import PageHeader from 'components/shared/PageHeader';
import ButtonsToolbar from 'components/shared/ButtonsToolbar';
import FiltersToolbar from 'components/shared/filters/FiltersToolbar';
import SortingToolbar from 'components/shared/SortingToolbar';

import MainHeading from 'components/shared/MainHeading';
import PageDataWrapper from 'pages/shared/PageDataWrapper.js';

import KitOrdersList from 'components/kit-orders/details/KitOrdersList';

let getYYYYMMDD = (ts) => {
  var a = new Date(ts);
  var months = ['01','02','03','04','05','06','07','08','09','10','11','12'];
  var year = a.getFullYear();
  var month = months[a.getMonth()];
  var date = a.getDate();
  var hour = a.getHours();
  var min = a.getMinutes();
  var sec = a.getSeconds();

  return year + '-' + month + '-' + date;
};

let tsMinusDays = (now, days) => {
  return now - 1000 * 60 * 60 * 24 * days;
};

class KitProblemsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      working: false,
      fetching: false,

      error: '',

      kit: {},

      problems: {
        num_problems: 0,
        num_kits: 0,
        num_students: 0,

        dupes: null,
        unlocated: []
      }
    };

    this.refreshProblems = this.refreshProblems.bind(this);
    this.handleRefuseDupe = this.handleRefuseDupe.bind(this);
  }

  componentDidMount() {
    const { groupId, kitId } = this.props.match.params;

    // get kit (we don't have an endpoint for the single kit, so we have to cycle all of them)
    API.call('GET', Settings.V3_API_URL + '/kit-groups/' + groupId + '/kits?offset=0&limit=-1&access_token=' + Auth.getToken(), {}, (response, error) => {
      if (error) {
        this.setState({
          error: error.message + ' while getting kits'
        });

        return false;
      }

      if (response.data && response.data.kits.length) {
        response.data.kits.forEach((kit, i) => {
          if (kit.id == kitId) {
            this.setState({
              kit: kit
            });
          }
        });
      }
    });

    return this.refreshProblems();
  }

  refreshProblems() {
    const { groupId, kitId } = this.props.match.params;

    this.setState({
      fetching: true
    });

    API.call('GET', Settings.V1_API_URL + '/kit-requests/problems?kit_id=' + kitId + '&offset=0&limit=-1&access_token=' + Auth.getToken(), {}, (response, error) => {
      if (error) {
        console.dir(error);

        this.setState({
          fetching: false,
          error: error.message + ' while getting kit request problems'
        });

        return false;
      }

      this.setState({
        fetching: false,

        problems: {
          num_problems: response.data.num_kits,
          num_kits: response.data.num_kits,
          num_students: response.data.num_students,

          dupes: response.data.dupes,
          unlocated: response.data.unlocated
        }
      });
    });
  }

  handleRefuseDupe(request, group, e) {
    if (this.state.working) {
      e.preventDefault();

      return false;
    }

    if (window.confirm('Rifiutare questa richiesta?')) {
      console.log('Change status of ' + request.id + ' from ' + request.status + ' to ' + Settings.V1_API_STATUS_REFUSED);
      console.dir(request);

      this.setState({
        working: true,
      });

      request.status = Settings.V1_API_STATUS_REFUSED;
      API.call('PUT', '/kits/' + request.kit_id + '/kit-requests/' + request.id + '?access_token=' + Auth.getToken(), request, (response, error) => {
        if (error) {
          console.dir(error);

          this.setState({
            working: false,
            error: error.message + ' while getting kit request problems'
          });

          return false;
        }

        this.setState({
          working: false
        });

        return this.refreshProblems();

      });
    } else {
      e.preventDefault();

      return false;
    }
  }


  render() {
    const { groupId, kitId } = this.props.match.params;
    var kitInfo = this.state.kit ? this.state.kit.name : <Spinner message="Recupero info kit..." />;
    var dupes = [];

    return (
      <div>
        {
          (this.state.fetching || this.state.working) ? (
            <div style={{
              position: 'fixed',
              top: 0,
              left: 0,
              zIndex: 9999999,

              width: '100vw',
              height: '100vh',

              backgroundColor: 'rgba(255, 255, 255, 0.7)'
            }}>
              <div style={{
                position: 'fixed',
                marginTop: '50vh',
                top: '-35px',
                marginLeft: '50vw',
                left: '-115px',
                zIndex: 9999999 + 1,

                width: '200px',
                height: '40px',
                padding: '15px',

                border: '0px solid red'
              }}>
                <h4 className="text-center"><Spinner message="Attendere..." /></h4>
              </div>
            </div>
          ) : ""
        }

        <div className="container">
          <div className="row">
            <div className="col-8">
              <p>
                {
                  (new URLSearchParams(this.props.location.search)).get('back') == 'details' ? (
                    <Link to={'/kit-orders/' + kitId + '/overview/'}><i className="fa fa-arrow-left" /> Torna alle richieste</Link>
                  ) : (
                    <Link to="/kits/overview/"><i className="fa fa-arrow-left" /> Torna all'overview</Link>
                  )
                }
              </p>
            </div>
            <div className="col-4 text-right"></div>
          </div>

          {
            this.state.error ? (
              <div className="alert alert-danger"><h2>Oh, mamma!</h2><p>{this.state.error}</p></div>
            ) : (
              <div>
                <div className="row">
                  <div className="col-md-8">
                    <h1>Problemi kit {kitInfo} {this.state.fetching == false ? '(' + this.state.problems.num_problems + ')' : ''}</h1>
                  </div>
                  <div className="col-md-4"></div>
                </div>

                <div className="mt-4">
                  <h2 className="mt-4 mb-3"><i className="fa fa-copy" /> Doppioni</h2>
                  {
                    this.state.problems.dupes && Object.keys(this.state.problems.dupes).length ? (
                      Object.keys(this.state.problems.dupes).map((group) => {
                        return (
                          <div className="card mb-4">
                            <div className="card-header">
                              <h4 className="mt-0 mb-0 text-muted">{this.state.problems.dupes[group][0].class_type} {this.state.problems.dupes[group][0].class_sec} {this.state.problems.dupes[group][0].school_name} ({this.state.problems.dupes[group][0].teacher_first_name} {this.state.problems.dupes[group][0].teacher_last_name}) x {this.state.problems.dupes[group].length}</h4>
                            </div>
                            <div className="card-body">
                              <KitOrdersList orders={this.state.problems.dupes[group]} onDelete={this.handleRefuseDupe} disabled={this.state.working ? true : false} />
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <div className="alert alert-success">
                        Nessun doppione :-)
                      </div>
                    )
                  }

                  <h2 className="mt-4 mb-3"><i className="fa fa-school" /> ID localit&agrave; mancante</h2>
                  {
                    this.state.problems.unlocated.length ? (
                      <KitOrdersList orders={this.state.problems.unlocated} />
                    ) : (
                      <div className="alert alert-success">
                        Tutte le scuole sono OK :-)
                      </div>
                    )
                  }
                </div>
              </div>
           )
          }
        </div>
      </div>
    );
  }
}

export default KitProblemsPage;



// WEBPACK FOOTER //
// ./src/pages/kits/KitProblemsPage.js